// extracted by mini-css-extract-plugin
export default {"checkbox__checkmark":"p_V3eg","checkbox__label":"ZVESKg"};